import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type TrustAccountActivatedToastProps = {
  toastId: string | number;
  onNavigate: () => void;
};

export const TrustAccountActivatedToast: FC<TrustAccountActivatedToastProps> = ({
  toastId,
  onNavigate
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ToastCard
      iconName="sollapay:check"
      title={t('activation.activatedToast.title')}
      description={t('activation.activatedToast.description')}
      action={{label: t('activation.activatedToast.actionLabel'), onClick: onNavigate}}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('activation.activatedToast.close')}
    />
  );
};

export function showTrustAccountActivatedToast(
  trustAccountId: string,
  onNavigate: () => void
): void {
  const toastId = `trust-activated-${trustAccountId}`;
  toast.custom(id => <TrustAccountActivatedToast toastId={id} onNavigate={onNavigate} />, {
    id: toastId,
    duration: 60000
  });
}
